import { SearchIcon, FilterIcon } from 'lucide-react'
import { useNavigate } from 'react-router'

export const JobsFilter = ({
    filterStatus,
    setFilterStatus,
    searchQuery,
    setSearchQuery,
}) => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col space-y-4 md:flex-row md:items-center md:justify-between md:space-y-0">
            <div className="relative rounded-md shadow-sm max-w-lg">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <SearchIcon className="h-5 w-5 text-gray-400" />
                </div>
                <input
                    type="text"
                    className="focus:outline-none focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 sm:text-sm border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 rounded-md py-2 px-4 border"
                    placeholder="Search job titles or locations..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>
            <div className="flex items-center space-x-4">
                <div className="flex items-center">
                    <FilterIcon className="h-5 w-5 text-gray-400 mr-2" />
                    <span className="text-sm text-gray-500 dark:text-gray-400">Filter:</span>
                </div>
                <select
                    className="block w-full py-2 px-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    value={filterStatus}
                    onChange={(e) => setFilterStatus(e.target.value)}
                >
                    <option value="all">All Jobs</option>
                    <option value="active">Active</option>
                    <option value="closed">Closed</option>
                </select>
                <button onClick={() => navigate("/jobpost")} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700">
                    + New Job
                </button>
            </div>
        </div>
    )
}
